import {Component, effect, Input} from '@angular/core';
import {SidebarService} from '../../sidebar-form/sidebar.service';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import {CommonModule} from '@angular/common';
import {CytoscapeService} from '../../services/cy-services/cytoscape.service';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'maporium-edit-mode-button',
  imports: [
    MatButtonModule,
    MatTooltipModule,
    CommonModule,
    TranslatePipe
  ],
  template: `
    <div class="additional-section top d-flex flex-row justify-content-end" *ngIf="!readonly">
      <div class="toggle-container">
        <div
          class="toggle-part"
          [class.active]="!isEditMode"
          [matTooltip]="'TOOLBAR.SWITCH_TO_VIEW_MODE' | translate"
          (click)="disableEditMode()"
          role="button"
        >
          <span class="icon-smap-role-viewer"></span>
        </div>
        <div
          class="toggle-part"
          [class.active]="isEditMode"
          [matTooltip]="'TOOLBAR.SWITCH_TO_EDIT_MODE' | translate"
          (click)="enableEditMode()"
          role="button"
        >
          <span class="icon-smap-role-editor"></span>
        </div>
      </div>
    </div>
  `,
  styles: `
    .toggle-container {
      display: flex;
      border: 1px solid #000;
      border-radius: 6px;
      overflow: hidden;
      height: 25px;
      font-size: 16px;
      background-color: white;
    }

    .toggle-part {
      padding: 0 4px;
      width: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background-color: transparent;
      transition: background-color 0.2s ease;
    }

    .toggle-part.active {
      background-color: #e7f1fa;
    }

    .toggle-part:first-child {
      border-right: 1px solid black;
    }

    .icon-smap-role-viewer,
    .icon-smap-role-editor {
      //font-size: 22px;
    }

  `
})
export class EditModeButtonComponent {
  @Input() readonly: boolean | null | undefined = false;
  public isEditMode = false;

  constructor(private sidebarService: SidebarService, private cyService: CytoscapeService) {
    effect(() => {
      this.isEditMode = this.sidebarService.getEditModeSignal();
    });
  }


  public enableEditMode() {
    this.isEditMode = true;
    this.sidebarService.enableEditMode();
  }

  public disableEditMode() {
    this.isEditMode = false;
    this.sidebarService.disableEditMode();
    const cy = this.cyService.cy;
    if (cy) {
      cy.nodes().removeData('isNew');
    }
  }

  public toggleEditMode() {
    this.isEditMode = !this.isEditMode;
    if (this.isEditMode) {
      this.sidebarService.enableEditMode();
    } else {
      this.sidebarService.disableEditMode();
    }
  }
}
